import * as _ from 'lodash';
import { Alert, Button, Modal } from 'react-bootstrap';
import { IPassMissingRecipientProfile } from '@nkr/models/index';
import { TableWrapper } from '../styles';

interface IProps {
    show: boolean,
    items: IPassMissingRecipientProfile[],
    onClose: () => void,
}

const PassMissingRecipientProfiles = (props: IProps) => {
    if (props.items.length == 0) {
        return <></>;
    }

    return (
        <Modal backdrop='static' show={props.show} bsSize='medium' onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>Patient Intake Profiles Pending Completion</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Alert bsStyle='info' bsSize='sm'>
                    The following patient intake registrants have been flagged for missing recipient profiles...
                </Alert>
                <div style={{ maxHeight: 400, overflowY: 'scroll' }}>
                    <TableWrapper className='table table-condensed table-striped table-bordered'>
                        <thead>
                            <tr>
                                <th>Row</th>
                                <th><strong>First Name</strong></th>
                                <th><strong>Last Name</strong></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.items.map((item, i) =>
                                <tr key={'pass-' + i}>
                                    <td>{i + 1}</td>
                                    <td>{item.firstName}</td>
                                    <td>{item.lastName}</td>
                                    <td>
                                        <a href={`center/${item.centerId}/recipients/patient-intake/all?medicalRecordId=${item.medicalRecordId}&actionCenter=1`}>
                                            Click Here
                                        </a>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </TableWrapper>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default PassMissingRecipientProfiles;